module.exports = __webpack_public_path__ + "img/welcome.b717acff.png";